import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "font-bold flex-center flex-col rounded relative"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-3 h-3 bg-slate-100 rotate-45 self-center absolute bottom-0 left-1/2 -translate-x-1/2 -mb-1.5"
}, null, -1);
export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarFinish',
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Icon, {
        icon: _ctx.IconEnum.FlagCheckered,
        size: "2.5rem",
        class: "my-1"
      }, null, 8, ["icon"]), _hoisted_2]);
    };
  }
});